import clsx from "clsx";
import { CMSLink } from "./CMSLink";
import { GeneralInformation } from "@/payload-types";
import { AnyARecord } from "node:dns";

export default function ContactButton({
  links,
  className,
}: {
  links: any;
  className: string;
}) {
  return (
    <div className={clsx("flex items-center gap-x-6", className)}>
      {links.map(({ link, id }: { link: any; id: AnyARecord }) => (
        <CMSLink
          key={id}
          {...link}
          className="rounded-lg bg-[#0079AD] px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-[#005E87] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
        />
      ))}
    </div>
  );
}
